import styled from 'styled-components';

const StyledIndustriesIframeBlock = styled.div`
  position: relative;
  padding: 0 16px;
  .block--content{
    position: relative;
    width: 100%;
  }
  .block--bg{
    position: absolute;
    width: 100%;
    height: 100%;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px; 
  }
  .block--flex{
    position: relative;
    padding-top: ${props => props.theme.components_spacing_desk.xlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
    display: flex;
    align-items: ${props => props.isLanding ? 'center' : 'flex-start'};
    justify-content: space-between;
  }
  .block--col{
    flex: 0 0 50%;
    max-width: 50%;
  }
  .block--col.block--col-iframe{
    margin-top: ${props => props.isLanding ? '0' : '-200px'};
  }
  .block--text-wrap{
    position: relative;
    width: 83.33%;
  }
  .block--subtitle{
    opacity: .5;
  }
  .block--subtitle, h4, .block--paragraph{
    margin-bottom: 24px;
  }
  iframe{
    width: 100%;
  }
  .block--col.block--col-iframe img{
    display: block;
    width: 100%;
  }
  .overlay--zoom{
    position: fixed;
    width: 100vw;
    height: 100vh;
    transform: translateX(-100%);
    top: 0; 
    left: 0;
    z-index: 10;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .overlay--zoom iframe {
    position: relative;
    top: 0;
    left; 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    border: none;
  }
  .overlay--zoom .close--overlay{
    position: absolute;
    right: 64px;
    top: 40px;
    z-index: 11;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }

  .overlay--zoom .close--overlay img {
    display: block;
    width: 100%;
  }
  .mobile-tap{
    display: none;
  }
  @media screen and (max-width: 1439px){
    .block--flex{
      padding-top: ${props => props.theme.components_spacing_tablet.xlarge}px;
      padding-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
      padding-right: 105px;
    }
    .block--col.block--col-iframe{
      margin-top: ${props => props.isLanding ? '0' : '-110px'};
    }
  }
  @media screen and (max-width: 1024px){
    .mobile-tap{
      position: relative;
      margin: -40px auto 40px;
      display: block;
      text-align: center;
      padding: 0;
      transition: opacity .25s ease-out;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;
      background-color: ${ props => props.theme.colors.green_secondary};
    }
  }
  @media screen and (max-width: 1023px){
    padding-top: ${props => props.isLanding ? 0 : '160px'};
    .block--flex{
      flex-direction: column;
      padding-right:0;
      padding-top: ${props => props.isLanding ? 0 : '160px'};
      padding-bottom: 160px;
    }
    .block--col-iframe{
      position: ${props => props.isLanding ? 'relative' : 'absolute'};
      max-width: 58.33%;
      width: 58.33%;
      transform: ${props => props.isLanding ? 'translateY(0,0)' : 'translateY(calc(-50% - 80px))'};
    }
    .block--col-text{
      max-width: 83.33%;
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 767px){
    padding-left: 8px;
    padding-right: 8px;
    .block--flex{
      flex-direction: ${props => props.isLanding ? 'column-reverse' : 'column'};
      padding-right:0;
      padding-top: ${props => props.isLanding ? 0 : '128px'};
      padding-bottom: 128px;
    }
    .block--col-text{
      max-width: 100%;
      padding: 0 16px;
    }
    .block--col-iframe{
      max-width: 100%;
      width: 100%;
      transform: ${props => props.isLanding ? 'translateY(0,0)' : 'translateY(calc(-50% - 64px))'};
    }
    .overlay--zoom .close--overlay{
      right: 24px;
    }
  }
`;

export {
  StyledIndustriesIframeBlock,
};

